import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ff521d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "Откуда", -1))
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "Куда", -1))
const _hoisted_8 = { class: "Table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "TableHeader" }, [
  /*#__PURE__*/_createElementVNode("div", null, "20-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "10-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "5-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "3-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "Газель")
], -1))
const _hoisted_10 = { class: "TableBody" }
const _hoisted_11 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вес:", -1))
const _hoisted_13 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Кубатура:", -1))
const _hoisted_15 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вес:", -1))
const _hoisted_17 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Кубатура:", -1))
const _hoisted_19 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вес:", -1))
const _hoisted_21 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Кубатура:", -1))
const _hoisted_23 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вес:", -1))
const _hoisted_25 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Кубатура:", -1))
const _hoisted_27 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вес:", -1))
const _hoisted_29 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Кубатура:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "max",
    scrollable: "",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.confirmButtonText,
    loading: _ctx.state.is_loading,
    onCancel: _ctx.onCancel,
    onConfirm: _ctx.onConfirm
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_the_select, {
          value: _ctx.state.sender_city,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.sender_city) = $event)),
          placeholder: "Выберите из списка",
          loading: _ctx.cities_state.is_loading,
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          failed: _ctx.cities_state.is_failed,
          options: _ctx.cities_state.list,
          "error-text": "При получении списка городов произошла ошибка",
          "is-invalid": _ctx.state_form$.sender_city.$error,
          "validation-errors": _ctx.state_form$.sender_city.$errors,
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "loading", "disabled", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transit_cities, (city, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `transit-city-${i}`,
            class: "grid grid-cols-1 gap-3"
          }, [
            _createElementVNode("div", _hoisted_3, "Транзит №" + _toDisplayString(i + 1), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_select, {
                class: "w-full",
                value: _ctx.state.transit_cities[i],
                "onUpdate:value": ($event: any) => ((_ctx.state.transit_cities[i]) = $event),
                placeholder: "Выберите из списка",
                loading: _ctx.cities_state.is_loading,
                disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                failed: _ctx.cities_state.is_failed,
                options: _ctx.cities_state.list,
                "error-text": "При получении списка городов произошла ошибка",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "onRefresh"]),
              _createVNode(_component_the_button, {
                class: "red text small",
                onClick: ($event: any) => (_ctx.deleteTransitCity(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_the_button, {
          class: "primary text small",
          onClick: _ctx.addTransitCity
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Добавить город транзит ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_7,
        _createVNode(_component_the_select, {
          value: _ctx.state.receiver_city,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.receiver_city) = $event)),
          placeholder: "Выберите из списка",
          loading: _ctx.cities_state.is_loading,
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          failed: _ctx.cities_state.is_failed,
          options: _ctx.cities_state.list,
          "error-text": "При получении списка городов произошла ошибка",
          "is-invalid": _ctx.state_form$.receiver_city.$error,
          "validation-errors": _ctx.state_form$.receiver_city.$errors,
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "loading", "disabled", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_the_input, {
                  placeholder: "Вес",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.weightLoadStandard_6,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.weightLoadStandard_6) = $event)),
                  "is-invalid": _ctx.state_form$.weightLoadStandard_6.$error,
                  "validation-errors": _ctx.state_form$.weightLoadStandard_6.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_the_input, {
                  placeholder: "Кубатура",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.cubatureLoadStandard_6,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.cubatureLoadStandard_6) = $event)),
                  "is-invalid": _ctx.state_form$.cubatureLoadStandard_6.$error,
                  "validation-errors": _ctx.state_form$.cubatureLoadStandard_6.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_the_input, {
                  placeholder: "Вес",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.weightLoadStandard_5,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.weightLoadStandard_5) = $event)),
                  "is-invalid": _ctx.state_form$.weightLoadStandard_5.$error,
                  "validation-errors": _ctx.state_form$.weightLoadStandard_5.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_the_input, {
                  placeholder: "Кубатура",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.cubatureLoadStandard_5,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.cubatureLoadStandard_5) = $event)),
                  "is-invalid": _ctx.state_form$.cubatureLoadStandard_5.$error,
                  "validation-errors": _ctx.state_form$.cubatureLoadStandard_5.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_the_input, {
                  placeholder: "Вес",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.weightLoadStandard_3,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.weightLoadStandard_3) = $event)),
                  "is-invalid": _ctx.state_form$.weightLoadStandard_3.$error,
                  "validation-errors": _ctx.state_form$.weightLoadStandard_3.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_the_input, {
                  placeholder: "Кубатура",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.cubatureLoadStandard_3,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.cubatureLoadStandard_3) = $event)),
                  "is-invalid": _ctx.state_form$.cubatureLoadStandard_3.$error,
                  "validation-errors": _ctx.state_form$.cubatureLoadStandard_3.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_the_input, {
                  placeholder: "Вес",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.weightLoadStandard_2,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.weightLoadStandard_2) = $event)),
                  "is-invalid": _ctx.state_form$.weightLoadStandard_2.$error,
                  "validation-errors": _ctx.state_form$.weightLoadStandard_2.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_the_input, {
                  placeholder: "Кубатура",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.cubatureLoadStandard_2,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cubatureLoadStandard_2) = $event)),
                  "is-invalid": _ctx.state_form$.cubatureLoadStandard_2.$error,
                  "validation-errors": _ctx.state_form$.cubatureLoadStandard_2.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_the_input, {
                  placeholder: "Вес",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.weightLoadStandard_1,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.weightLoadStandard_1) = $event)),
                  "is-invalid": _ctx.state_form$.weightLoadStandard_1.$error,
                  "validation-errors": _ctx.state_form$.weightLoadStandard_1.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_the_input, {
                  placeholder: "Кубатура",
                  disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                  value: _ctx.state.cubatureLoadStandard_1,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.cubatureLoadStandard_1) = $event)),
                  "is-invalid": _ctx.state_form$.cubatureLoadStandard_1.$error,
                  "validation-errors": _ctx.state_form$.cubatureLoadStandard_1.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "loading", "onCancel", "onConfirm"]))
}